import { Component, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { BaseComponent } from 'src/app/models/base-component';
import { CampeonatosService } from '../../services/campeonatos/campeonatos.service';
import { GlobalVariable } from 'src/app/global';
import { Util } from 'src/app/utils/utils';
import { PopupConfirmacionComponent } from 'src/app/base/components/popup-confirmacion/popup-confirmacion.component';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { ClientesService } from 'src/app/snapquick/services/clientes/clientes.service';
import { RegistroClienteComponent } from 'src/app/base/components/registro-cliente/registro-cliente.component';
import { RolesPartidosService } from '../../services/roles-partidos/roles-partidos.service';
import { Socket } from 'ngx-socket-io';
import { RegistroJugadorComponent } from '../registro-jugador/registro-jugador.component';
import * as CryptoJS from 'crypto-js';
import { TarjetasJugadorComponent } from '../tarjetas-jugador/tarjetas-jugador.component';
import { ProductosService } from 'src/app/snapquick/services/productos/productos.service';
import { ClientesHistoricoVentasComponent } from 'src/app/snapquick/components/clientes-historico-ventas/clientes-historico-ventas.component';

declare const PDFDocument:any;
declare const blobStream:any;
declare const qr:any
declare const $:any;
declare const resaltarPestañaMenu:any;
declare const aplicarSubidaArchivo:any;
declare const aplicarVisorImagenes:any;

@Component({
  selector: 'app-campeonatos',
  templateUrl: './campeonatos.component.html',
  styleUrls: ['./campeonatos.component.css']
})
export class CampeonatosComponent extends BaseComponent implements OnInit {

  categoria_tab:any={};
  campeonatos:any[]=[];
  equipos:any[]=[];
  jugadores:any[]=[];
  campeonato:any;
  cuentas_clientes:any[]=[];
  equipo:any;
  tipo_categoria:any;
  tipo_nivel:any;
  tipo_disciplina:any
  searching = false;
  searchFailed = false;
  cliente_registrado:boolean=false;
  razon_busqueda:any;
  modalCliente:NgbModalRef;
  modalJugador:NgbModalRef;
  tabla_equipo_general:any={habilitar_jugadores:false};
  producto_busqueda:any;

  @ViewChildren('campeonatos') campeonatos_lectura: QueryList<any>;
  modalHistoricoVentas:NgbModalRef;

  modal_campeonato_modificacion:NgbModalRef;
  @ViewChild('modal_campeonato_modificacion')
  private modal_campeonato_modificacion_ref: TemplateRef<any>;

  modal_lista_equipos:NgbModalRef;
  @ViewChild('modal_lista_equipos')
  private modal_lista_equipos_ref: TemplateRef<any>;

  modal_equipo_modificacion:NgbModalRef;
  @ViewChild('modal_equipo_modificacion')
  private modal_equipo_modificacion_ref: TemplateRef<any>;

  modal_lista_jugadores:NgbModalRef;
  @ViewChild('modal_lista_jugadores')
  private modal_lista_jugadores_ref: TemplateRef<any>;

  modal_jugador_modificacion:NgbModalRef;
  @ViewChild('modal_jugador_modificacion')
  private modal_jugador_modificacion_ref: TemplateRef<any>;

  modal_configuracion_tarjeta_jugador:NgbModalRef;
  @ViewChild('modal_configuracion_tarjeta_jugador')
  private modal_configuracion_tarjeta_jugador_ref: TemplateRef<any>;

  modal_configuracion_pdf_rol_partido:NgbModalRef;
  @ViewChild('modal_configuracion_pdf_rol_partido')
  private modal_configuracion_pdf_rol_partido_ref: TemplateRef<any>;

  modal_saldo_equipos:NgbModalRef;
  @ViewChild('modal_saldo_equipos')
  private modal_saldo_equipos_ref: TemplateRef<any>;

  modal_impresion_tarjetas_jugador:NgbModalRef;

  constructor(private router: Router,
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    private toastr: ToastrService,
    public campeonatosService:CampeonatosService,
    public clientesService:ClientesService,
    public rolesPartidosService:RolesPartidosService,
    private socket: Socket,
    public productosService:ProductosService) { 
      super(persistenciaService,modalService,generalService,usuarioService);
    }

  ngOnInit(): void {
    this.init();
		this.buscarAplicacion(this.router.url.substring(1));
		this.configuracion_pagina={};
		this.filter={
			id_empresa:this.usuario.id_empresa
		}
		//this.obtenerConfiguracionPagina(GlobalVariable.Dictionary.CODIGO_APP_RUTAS);

    this.column = "fecha_inicio";
		this.getSearch(this.text_search,null);
  }

  ngAfterViewInit() {
		resaltarPestañaMenu(this.router.url.substring(1)+"1");
    this.campeonatos_lectura.changes.subscribe(t => {
      aplicarVisorImagenes("imagen-campeonato-vista");
    });
  }

  getItems(){
		this.blockUI.start('Recuperando... espere por favor!');
		this.campeonatosService.obtenerListaCampeonatos(this).subscribe((dato:any) => {
			this.setPages(dato.paginas);
			this.campeonatos=dato.campeonatos;
			this.blockUI.stop();
		});
	}

  abrirConfiguracionAplicacion(){
		
	}

  async crearNuevoCampeonato(){
    this.producto_busqueda="";
    let codigo_nuevo=await this.obtenerUltimoCodigo(GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_CAMPEONATO);
    this.campeonato={      
        id_empresa: this.usuario.id_empresa, id_usuario:this.usuario.id,
        codigo:codigo_nuevo,
        activo:true,
        configuracion_tarjeta_jugador:{
          fondo_color_tarjeta:"#06427e",
          titulo_color_liga:"#ffffff",
          titulo_color_jugador:"#ffff00",
          enunciados_color:"#ffffff",
          datos_color:"#ffff00"
        }
    }
    this.abrirRegistroCampeonato();
  }

  abrirRegistroCampeonato(){
    this.modal_campeonato_modificacion=this.modalService.open(this.modal_campeonato_modificacion_ref, {
      windowClass: 'registro-campeonato',
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      container: 'body'
    });
    this.modal_campeonato_modificacion.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    aplicarSubidaArchivo('dropzone','preview-template',this,'subirArchivo','eliminarArchivo',{maximo_tamano_archivo:10});
    aplicarSubidaArchivo('fondo-tabla','fondo-tabla-template',this,'subirArchivoFondo','eliminarArchivoFondo',{maximo_tamano_archivo:10});
    aplicarSubidaArchivo('fondo-rol','fondo-rol-template',this,'subirArchivoRol','eliminarArchivoRol',{maximo_tamano_archivo:10});
  }

  subirArchivo(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.campeonato.logo=base64EncodedImage;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  eliminarArchivo(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.campeonato.logo=null;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  subirArchivoFondo(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.campeonato.fondo_tabla_posiciones=base64EncodedImage;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  eliminarArchivoFondo(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.campeonato.fondo_tabla_posiciones=null;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  subirArchivoRol(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.campeonato.fondo_rol_partido=base64EncodedImage;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  eliminarArchivoRol(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.campeonato.fondo_rol_partido=null;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  validarFormularioRegistroCampeonato(){
		let res=true;
		if(!this.campeonato.nombre){
			this.toastr.error("Debe especificar el nombre del campeonato!");
			res=false;
		}
		if(!this.campeonato.fecha_inicio_texto || !this.campeonato.fecha_inicio_texto.year || !this.campeonato.fecha_inicio_texto.month || !this.campeonato.fecha_inicio_texto.day){
      res=res && false;
      this.toastr.error("Debe especificar la fecha de inicio completa para el campeonato!");
    }
		return res;
	}

	guardarCampeonato(){
		if(this.validarFormularioRegistroCampeonato()){
			this.blockUI.start();
      this.campeonato.fecha_inicio=Util.convertirObjetoAfecha(this.campeonato.fecha_inicio_texto);
      this.campeonato.fecha_fin=this.campeonato.fecha_fin_texto?Util.convertirObjetoAfecha(this.campeonato.fecha_fin_texto):null;
			if(this.campeonato.id){
				this.campeonatosService.actualizarCampeonato(this.campeonato).subscribe((res:any) => {
					this.blockUI.stop();
					this.toastr.success("Campeonato registrado satisfactoriamente");
          this.getItems();
					this.modal_campeonato_modificacion.close();
				});
			}else{
				this.campeonatosService.guardarCampeonato(this.campeonato).subscribe((res:any) => {
          this.actualizarUltimoCodigo(GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_CAMPEONATO);
					this.blockUI.stop();
					this.toastr.success(res.mensaje);
          this.getItems();
					this.modal_campeonato_modificacion.close();
				});
			}
		}
		
	}

  async modificarCampeonato(campeonato){
    this.producto_busqueda="";
    this.campeonato=campeonato;
    this.campeonato.fecha_inicio_texto=Util.convertirFechaAObjectoFecha(new Date(this.campeonato.fecha_inicio));
    this.campeonato.fecha_fin_texto=this.campeonato.fecha_fin?Util.convertirFechaAObjectoFecha(new Date(this.campeonato.fecha_fin)):null;
    this.abrirRegistroCampeonato();
  }

  async obtenerCategoriasEquiposEmpresa(){
		this.tipo_categoria=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_EQUIPO_CATEGORIAS).toPromise();
	}

  async obtenerNivelesEquiposEmpresa(){
		this.tipo_nivel=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_EQUIPO_NIVELES).toPromise();
	}

  async obtenerDisciplinasEquiposEmpresa(){
		this.tipo_disciplina=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_EQUIPO_DISCIPLINAS).toPromise();
	}

  async verEquipos(campeonato){
    this.campeonato=campeonato;    
    this.obtenerEquiposCampeonato();
    this.obtenerCategoriasEquiposEmpresa();
    this.obtenerNivelesEquiposEmpresa();
    this.obtenerDisciplinasEquiposEmpresa();
    this.modal_lista_equipos=this.modalService.open(this.modal_lista_equipos_ref, {scrollable:true,windowClass:'lista-equipos',ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
    this.modal_lista_equipos.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  async crearNuevoEquipo(campeonato){
    this.razon_busqueda=null;
    this.cliente_registrado=false;
    let codigo_nuevo=await this.obtenerUltimoCodigo(GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_EQUIPO);
    this.equipo={   
        id_empresa:this.usuario.id_empresa,   
        id_campeonato: campeonato.id,
        codigo:codigo_nuevo,
        activo:true,
        cantidad_jugadores:0,
        cliente:{}
    }
    this.abrirRegistroEquipo();
  }

  abrirRegistroEquipo(){
    this.modal_equipo_modificacion=this.modalService.open(this.modal_equipo_modificacion_ref, {scrollable:true,ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
    this.modal_equipo_modificacion.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    aplicarSubidaArchivo('logo-equipo','preview-template-logo',this,'subirArchivoLogo','eliminarArchivoLogo',{maximo_tamano_archivo:10});
  }

  validarFormularioRegistroEquipo(){
		let res=true;
		if(!this.equipo.nombre){
			this.toastr.error("Debe especificar el nombre del equipo!");
			res=false;
		}
    if(!this.equipo.nivel){
			this.toastr.error("Debe especificar el nivel del equipo!");
			res=false;
		}
    if(!this.equipo.categoria){
			this.toastr.error("Debe especificar la categoria del equipo!");
			res=false;
		}
    if(!this.equipo.disciplina){
			this.toastr.error("Debe especificar la disciplina del equipo!");
			res=false;
		}
    if(!this.equipo.cliente.razon_social){
			this.toastr.error("Debe especificar el nombre del delegado!");
			res=false;
		}
    if(!this.equipo.cliente.telefono1){
			this.toastr.error("Debe especificar el telefono del delegado!");
			res=false;
		}
		return res;
	}

	guardarEquipo(){
		if(this.validarFormularioRegistroEquipo()){
			this.blockUI.start();
			if(this.equipo.id){
				this.campeonatosService.actualizarEquipo(this.equipo).subscribe((res:any) => {
					this.blockUI.stop();
					this.toastr.success(res.mensaje);
          this.obtenerEquiposCampeonato();
					this.modal_equipo_modificacion.close();
				});
			}else{
				this.campeonatosService.guardarEquipo(this.equipo).subscribe((res:any) => {
          this.actualizarUltimoCodigo(GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_EQUIPO);
					this.blockUI.stop();
					this.toastr.success(res.mensaje);
          this.obtenerEquiposCampeonato();
					this.modal_equipo_modificacion.close();
				});
			}
		}
		
	}

  obtenerEquiposCampeonato(){
    this.blockUI.start('Recuperando... espere por favor!');
		this.campeonatosService.obtenerListaEquipos(this.campeonato.id,0,0).subscribe((equipos:any) => {
      this.equipos=this.agruparPorCategoria(equipos);console.log(this.equipos);
      this.establecerCategoriaTab(this.equipos[0]);
			this.blockUI.stop();
		});
  }

  agruparPorCategoria = (lista) => {
    // 1. Agrupamos en un objeto intermedio usando la categoría como llave
    const grupos = lista.reduce((acc, equipo) => {
      const key = equipo.id_categoria+"-"+equipo.id_disciplina;

    if (!acc[key]) {
      // Creamos la estructura con la descripción y el array vacío
      acc[key] = {
            nombre: equipo.categoria.nombre, // Aquí agregas la descripción
            disciplina:equipo.disciplina.nombre,
            id: key,
            listaEquipos: []
          };
        }

        // Agregamos el equipo a la lista interna de ese objeto
        acc[key].listaEquipos.push(equipo);

        return acc;
      }, {})

    // 2. Convertimos los valores del objeto en un array de arrays
    return Object.values(grupos);
  }

  establecerCategoriaTab(categoria){
    this.categoria_tab=categoria;
  }

  subirArchivoLogo(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.equipo.logo=base64EncodedImage;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  eliminarArchivoLogo(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.equipo.logo=null;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  async modificarEquipo(equipo){
    this.equipo=equipo;
    this.equipo.cliente=equipo.cliente?equipo.cliente:{};  
    this.equipo.id_empresa=this.usuario.id_empresa;
    this.abrirRegistroEquipo();
  }

  async verJugadores(equipo){
    this.equipo=equipo;
    this.obtenerJugadoresEquipo();
    this.modal_lista_jugadores=this.modalService.open(this.modal_lista_jugadores_ref, {ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
    this.modal_lista_jugadores.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  async crearNuevoJugador(equipo){
    this.modalJugador = this.modalService.open(RegistroJugadorComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    this.modalJugador.componentInstance.equipo = equipo;
		this.modalJugador.componentInstance.usuario = this.usuario;
		
		this.modalJugador.componentInstance.alTerminar.subscribe((res) => {
			if(res){
				if(res.tiene_error){
					this.toastr.error(res.mensaje);
					this.toastr.error(res.stack.substring(0,500));
				}else{
					this.obtenerJugadoresEquipo();
					this.modalJugador.close();
				}
			}else{
				this.modalJugador.close();
			}
			
		});
  }

  obtenerJugadoresEquipo(){
    this.blockUI.start('Recuperando... espere por favor!');
		this.campeonatosService.obtenerListaJugadores(this.usuario.id_empresa,this.equipo.id).subscribe((jugadores:any) => {
			this.jugadores=jugadores;
			this.blockUI.stop();
		});
  }

  async modificarJugador(jugador_a_modificar){
    let jugador:any=jugador_a_modificar;
    jugador.persona.fecha_nacimiento_texto=jugador.persona.fecha_nacimiento?Util.convertirFechaAObjectoFecha(new Date(jugador.persona.fecha_nacimiento)):null;
    jugador.id_empresa=this.usuario.id_empresa;

    this.modalJugador = this.modalService.open(RegistroJugadorComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    this.modalJugador.componentInstance.equipo = this.equipo;
    this.modalJugador.componentInstance.jugador = jugador;
		this.modalJugador.componentInstance.usuario = this.usuario;
		
		this.modalJugador.componentInstance.alTerminar.subscribe((res) => {
			if(res){
				if(res.tiene_error){
					this.toastr.error(res.mensaje);
					this.toastr.error(res.stack.substring(0,500));
				}else{
					this.obtenerJugadoresEquipo();
					this.modalJugador.close();
				}
			}else{
				this.modalJugador.close();
			}
		});
  }

  abrirModalGeneracionPdfTarjetasJugador(){
    this.modal_impresion_tarjetas_jugador = this.modalService.open(TarjetasJugadorComponent, {windowClass:'tarjetas-jugador',scrollable:true,ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
		this.modal_impresion_tarjetas_jugador.componentInstance.usuario = this.usuario;
		
		this.modal_impresion_tarjetas_jugador.componentInstance.alTerminar.subscribe((res) => {
			this.modal_impresion_tarjetas_jugador.close();
		});
  }

  abrirModalConfiguracionTarjetaJugador(campeonato){
    this.campeonato=campeonato;
    this.campeonato.configuracion_tarjeta_jugador=this.campeonato.configuracion_tarjeta_jugador?this.campeonato.configuracion_tarjeta_jugador:{
      fondo_color_tarjeta:"#06427e",
      titulo_color_liga:"#ffffff",
      titulo_color_jugador:"#ffff00",
      enunciados_color:"#ffffff",
      datos_color:"#ffff00"
    }
    this.modal_configuracion_tarjeta_jugador=this.modalService.open(this.modal_configuracion_tarjeta_jugador_ref, {ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
    this.modal_configuracion_tarjeta_jugador.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  guardarConfiguracionTarjetaJugador(){
    this.blockUI.start();
    this.campeonatosService.actualizarComfiguracionTarjetaJugadorCampeonato(this.campeonato).subscribe((res:any) => {
      this.blockUI.stop();
      this.toastr.success(res.mensaje);
      this.modal_configuracion_tarjeta_jugador.close();
    });
  }

  abrirModalConfiguracionPdfRolPartido(campeonato){
    this.campeonato=campeonato;
    this.campeonato.configuracion_pdf_rol_partido=this.campeonato.configuracion_pdf_rol_partido?this.campeonato.configuracion_pdf_rol_partido:{
      distancia_partidos:30,
      mostrar_categoria:false,
      mostrar_disciplina:false,
      mostrar_escenario:false,
      campeonato_propio:true,
      caja_marcador:true,
      usar_rol_version:1,
      logo_longitud:25,
      logo_vertical:0     
    }
    this.modal_configuracion_pdf_rol_partido=this.modalService.open(this.modal_configuracion_pdf_rol_partido_ref, {ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
    this.modal_configuracion_pdf_rol_partido.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  guardarConfiguracionPdfRolPartido(){
    this.blockUI.start();
    this.campeonatosService.actualizarComfiguracionTarjetaJugadorCampeonato(this.campeonato).subscribe((res:any) => {
      this.blockUI.stop();
      this.toastr.success(res.mensaje);
      this.modal_configuracion_pdf_rol_partido.close();
    });
  }

  abrirPopupConfirmacionEliminacionJugador(jugador){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro de eliminar al jugador?";
		this.popupConfirmacion.componentInstance.data = jugador;
		
		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){
				this.eliminarJugador($e.data);
			}
			this.popupConfirmacion.close();
        });
	}
	  
	eliminarJugador(jugador){
		this.blockUI.start();
		this.campeonatosService.eliminarJugador(jugador).subscribe((dato:any)=>{
			this.blockUI.stop();
			if(dato.tiene_error){
				this.toastr.error(dato.mensaje);
			}else{
        this.obtenerJugadoresEquipo();
				this.toastr.success(dato.mensaje);
			}
		});
	}

  buscarCliente = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
	  switchMap( (term) =>  this.clientesService.buscarClienteNit(this.usuario.id_empresa,term,0)),
	  catchError(() => {
		this.searchFailed = true;
		return of([]);
	  })  ,
      tap(() => this.searching = false)
	)
	
  formatter = (x: any) => (x.id?(x.identificacion?x.identificacion:"")+" "+(x.razon_social?x.razon_social:""):"");

  cambiarClienteRegistrado(){
    this.cliente_registrado=!this.cliente_registrado;
  }

  establecerCliente(event){
    let cliente=(event.id || event.nit)?event:event.item;
    this.razon_busqueda=cliente.razon_social;
    this.equipo.cliente=cliente;
  }

  reiniciarCliente(){
    this.equipo.cliente={};
    this.razon_busqueda=null;
  }

  abrirPopupRegistroRapidoCliente(){
    this.modalCliente = this.modalService.open(RegistroClienteComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    this.modalCliente.componentInstance.cliente = JSON.parse(JSON.stringify(this.equipo.cliente));
    this.modalCliente.componentInstance.sucursales = [];
    this.modalCliente.componentInstance.sucursal = null;
		this.modalCliente.componentInstance.usuario = this.usuario;
		
		this.modalCliente.componentInstance.alTerminar.subscribe((res) => {
			if(res){
				if(res.tiene_error){
					this.toastr.error(res.mensaje);
					this.toastr.error(res.stack.substring(0,500));
				}else{
					this.establecerCliente(res.cliente);
					this.modalCliente.close();
				}
			}else{
				this.modalCliente.close();
			}
			
		});
  }

  buscarJugador = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
	  switchMap( (term) =>  this.campeonatosService.buscarJugador(this.campeonato.id,term)),
	  catchError(() => {
		this.searchFailed = true;
		return of([]);
	  })  ,
      tap(() => this.searching = false)
	)

  async enviarPendientesEconomicosEquipo(equipo){
    this.blockUI.start();
    let detalles_ventas_pendientes:any=await this.rolesPartidosService.obtenerDetallesVentaPendientes(equipo.cliente.id).toPromise();
    if(detalles_ventas_pendientes.length>0){
      let mensaje="🙋🏻‍♂️ Apreciado Delegado de *"+equipo.nombre+"*! 😔\n\n💴 Le informamos sobre el estado de pagos pendientes al Campeonato "+this.campeonato.nombre+":\n\n";
      let total=0;
      for(let i=0;i<detalles_ventas_pendientes.length;i++){
        let fecha_venta=new Date(detalles_ventas_pendientes[i].venta.fecha);
        let texto=detalles_ventas_pendientes[i].producto.nombre+(detalles_ventas_pendientes[i].descripcion?" "+detalles_ventas_pendientes[i].descripcion:"")+" "+(fecha_venta.getDate()+"/"+(fecha_venta.getMonth()+1)+"/"+fecha_venta.getFullYear());
        let descripcion="❓ "+"Bs "+detalles_ventas_pendientes[i].venta.saldo.toFixed(2)+" "+texto;
        mensaje=mensaje+descripcion+"\n";
        total=total+detalles_ventas_pendientes[i].venta.saldo;
      }

      mensaje=mensaje+"\n 💵 Total Bs "+total.toFixed(2);
      let envio:any={
        telefono_whatsapp:equipo.cliente.telefono1,
        mensaje:mensaje,
        empresa:{id:this.usuario.id_empresa}
      };
      this.socket.emit('enviarKardexEconomicoEstudianteWhatsapp',envio);
      this.toastr.success("Se envio el mensaje por whatsapp satisfactoriamente!");
    }else{
      this.toastr.info("El equipo no tiene deudas pendientes!");
    }
    this.blockUI.stop();
  }

  copiarEnlace(equipo){
    navigator.clipboard.writeText(GlobalVariable.SERVER_URL+"tor/club/"+CryptoJS.AES.encrypt(equipo.cliente.id.toString(),GlobalVariable.Dictionary.TIPO_RECURSOS_MULTIMEDIA).toString().replaceAll('/','Por21Ld'));
  }

  actualizarAtributoEquipo(equipo,atributo,valor){
		this.blockUI.start();
		let datos:any={
			atributo:atributo,
			valor:valor
		};
		if(equipo){
			datos.equipo=equipo;
		}else{
			datos.id_campeonato=this.campeonato.id;
		}
		this.campeonatosService.actualizarAtributoEquipo(datos).subscribe((res:any) => {
			this.obtenerEquiposCampeonato();
			this.toastr.success(res.mensaje);
			this.blockUI.stop();
		});
	}

  buscarProducto = (text$: Observable<string>) =>
      text$.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => this.searching = true),
      switchMap( (termp) =>  this.productosService.buscarProducto(this.usuario.id_empresa,termp)),
      catchError(() => {
      this.searchFailed = true;
      return of([]);
      })  ,
        tap(() => this.searching = false)
    )
    
    formatterProducto = (x: any) => (x.nombre);
  
    establecerProducto($event){
      this.campeonato.derecho_cancha=$event.item
    }

    iniciarDerechoCancha(){
      this.producto_busqueda="";
      this.campeonato.derecho_cancha=null;
    }

    verSaldosClientes(campeonato){
      this.campeonato=campeonato;
      this.blockUI.start('Recuperando... espere por favor!');
      this.campeonatosService.obtenerClientesCampeonato(campeonato.id).subscribe((clientes:any) => {
        const ids_clientes = clientes.map(cliente => cliente.cliente);
        const idString = ids_clientes.join(', ');
        let fecha_actual=new Date();
        let paginator={
          filter:{
            id_empresa:this.usuario.id_empresa,
            sucursales:this.usuario.empresa.usar_clientes_sucursal?Util.obtenerSucursalesUsuario(this.usuario):[{nombre:"TODOS",id:0}],
            sucursal: this.usuario.empresa.usar_clientes_sucursal?Util.obtenerSucursalesUsuario(this.usuario)[0]:{nombre:"TODOS",id:0},
            usuarios:[{nombre_usuario:"TODOS",id:0}],
            usuario: {nombre_usuario:"TODOS",id:0},
            cliente:null,
            contacto_cliente:null,
            cuentas_liquidadas:false,
            fecha_fin:{
              year: fecha_actual.getFullYear(), 
              month: (fecha_actual.getMonth()+1),
              day:fecha_actual.getDate()
            },
            categorias:[GlobalVariable.Dictionary.SELECCION_TODOS],
            categoria:GlobalVariable.Dictionary.SELECCION_TODOS,
            clientes:idString
          },
          itemsPerPage:0,
          currentPage:1,
          column:"saldo_cliente",
          direction:"desc",
          search:0
        }
        this.clientesService.obtenerCuentasPorCobrar(paginator).subscribe((dato:any) => {
          this.cuentas_clientes=dato.clientes;
          this.blockUI.stop();

          this.modal_saldo_equipos=this.modalService.open(this.modal_saldo_equipos_ref, {ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static', scrollable:true});
          this.modal_saldo_equipos.result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
          }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          });

        });
      });
    }

    async abrirEstadoCuentaCliente(cliente){
      this.modalHistoricoVentas = this.modalService.open(ClientesHistoricoVentasComponent, {windowClass:'historico-ventas', scrollable:true, ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
      this.modalHistoricoVentas.componentInstance.cliente = cliente;
      this.modalHistoricoVentas.componentInstance.usuario = this.usuario;
      this.modalHistoricoVentas.componentInstance.mostrar_filtro_fechas = false;
      this.modalHistoricoVentas.componentInstance.mostrar_boton_busqueda = false;
      this.modalHistoricoVentas.componentInstance.cuentas_liquidadas = this.filter.cuentas_liquidadas;
      this.modalHistoricoVentas.componentInstance.titulo_reporte = "CUENTAS POR COBRAR";
      
      this.modalHistoricoVentas.componentInstance.alTerminar.subscribe((res) => {
        this.modalHistoricoVentas.close();
      });
    }
}
